import { render, staticRenderFns } from "./AnuenciaFornecedorView.vue?vue&type=template&id=a779b064&scoped=true"
import script from "./AnuenciaFornecedorView.vue?vue&type=script&lang=js"
export * from "./AnuenciaFornecedorView.vue?vue&type=script&lang=js"
import style0 from "./AnuenciaFornecedorView.vue?vue&type=style&index=0&id=a779b064&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a779b064",
  null
  
)

export default component.exports